<h2 mat-dialog-title>{{ title }}</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <p>owner: {{ data.owner }} • {{ data.server.hostname }} • {{ data.plan }}</p>
  @if (step === 1) {
    <form [formGroup]="form">
      <app-input-field
        label="Type"
        placeholder="Select website type"
        type="select"
        [options]="types"
        formControlName="type"
        hint="Site, Alias or Subdomain"
      ></app-input-field>

      @for (control of controlsArray; track control.label) {
        @if (control.type !== 'checkbox') {
          @switch (control.controlName) {
            @case ('websiteId') {
              <app-input-field
                [label]="control.label"
                [placeholder]="control.placeholder || ''"
                [type]="control.type"
                [options]="websites() || []"
                [formControlName]="control.controlName"
                [(searchText)]="websiteSearchText"
                [errorMessages]="control.errors"
              ></app-input-field>
            }
            @case ('domain') {
              <app-input-field
                [label]="control.label"
                [placeholder]="control.placeholder || ''"
                [type]="control.type"
                [formControlName]="control.controlName"
                [suffixText]="(websiteSuffixText$ | async) || ''"
                [errorMessages]="control.errors"
              ></app-input-field>
            }
            @default {
              <app-input-field
                [label]="control.label"
                [placeholder]="control.placeholder || ''"
                [type]="control.type"
                [options]="control.options || []"
                [formControlName]="control.controlName"
                [errorMessages]="control.errors"
              ></app-input-field>
            }
          }
        }
      }

      <div class="checkboxes column">
        <mat-checkbox formControlName="enableEmail">Enable email service</mat-checkbox>
        <mat-checkbox formControlName="installWordpress">Install wordpress</mat-checkbox>
      </div>
    </form>
  } @else {
    <form [formGroup]="wordpressForm">
      <app-input-field
        label="WP Admin Username"
        formControlName="user"
        [errorMessages]="wpErrors['user']"
      ></app-input-field>

      <app-input-field
        label="WP Admin Password "
        type="password"
        autocomplete="new-password"
        formControlName="password"
        [errorMessages]="wpErrors['password']"
      ></app-input-field>

      <app-input-field
        label="Email"
        formControlName="email"
        [errorMessages]="wpErrors['email']"
      ></app-input-field>

      <div class="checkboxes column">
        <mat-checkbox formControlName="enableRedisCache">Enable Redis Cache</mat-checkbox>
        <mat-checkbox formControlName="enableW3TotalCache">Install W3 Total Cache</mat-checkbox>
        <mat-checkbox formControlName="enableWooCommerce">Install WooCommerce</mat-checkbox>
      </div>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button
    matButton="filled"
    (click)="submit()"
    [disabled]="form.invalid || (step === 2 && wordpressForm.invalid)"
  >
    @if (!form.controls.installWordpress.value) {
      <fa-icon matPrefix [icon]="['fas', 'plus']" size="sm"></fa-icon>
    }
    {{ primaryButtonText }}
  </button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
